import * as React from "react"

import { cn } from "@podcastsoundboard/ps-lib/ui"

/** Collapsible permanent sidebar (mini variant when closed). */
const Drawer = ({
  open,
  className,
  children,
}: {
  open?: boolean
  variant?: "permanent"
  className?: string
  children?: React.ReactNode
}) => (
  <aside
    className={cn(
      "relative flex h-full shrink-0 flex-col overflow-x-hidden whitespace-nowrap",
      "bg-paper text-text-primary shadow-paper transition-[width] duration-200",
      open ? "w-[240px]" : "w-14",
      className,
    )}
  >
    {children}
  </aside>
)

export default Drawer
